/* XES Layout Fix — moves Avada-reparented header elements back into the header */
document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.header-wrapper .header');
  if (!header) return;
  
  // Find orphaned elements that are direct children of body
  var nav = document.body.querySelector(':scope > .header__inline-menu');
  var icons = document.body.querySelector(':scope > .header__icons');
  var cart = document.body.querySelector(':scope > cart-notification');
  
  // Move nav back into header
  if (nav) {
    nav.removeAttribute('style');
    header.appendChild(nav);
  }
  
  // Move icons back into header
  if (icons) {
    icons.removeAttribute('style');
    header.appendChild(icons);
  }
  
  // Move cart-notification back to header section level
  if (cart) {
    cart.removeAttribute('style');
    var headerSection = document.querySelector('.section-header');
    if (headerSection) {
      headerSection.appendChild(cart);
    }
  }
});
